import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { CASE_COUNT_WEEK_QUERY } from '../../../graphql.js'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { csvUrl, getData } from '../CustomUtils'
import '../Custom.css'
import ColumnHeadings from '../ColumnHeadings.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'
import ResultsGrid from '../ResultsGrid.js'

const CASE_COUNT_WEEK = gql(CASE_COUNT_WEEK_QUERY)

export default function CaseCountWeekDetails({ location, byFirm }) {
  console.log('CaseCountWeekDetails rendered:', location, byFirm)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, CASE_COUNT_WEEK, 'caseCountWeekReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const resultRows = ResultsGrid(results, 0)
    const params = new URLSearchParams(location.search)
    const inputs = JSON.parse(params.get('inputs'))
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('BosSci/caseCountWeekReport/case_count_week_report', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered>
          <ReportHeading title={`${inputs.firm} Complaints entered during week ${inputs.week} of ${inputs.year}`} widths={['0%', '50%', '50%']} />
          <tbody>
            <ColumnHeadings results={results} />
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}